import {css} from '@emotion/react'

const defaultGetText = (a) => a

const cssViewText = css({
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
})

const ViewText = ({
    getText = defaultGetText,
    value,
    ...props
}) => {
    const text = (() => {
        if (value || 0 === value) {
            return getText(value)
        }
        else {
            return ''
        }
    })()

    return (
        <div
            css={cssViewText}
            title={text}
            {...props}
        >
            {text}
        </div>
    )
}

export default ViewText
